import React, { useEffect, useState } from "react";

const slides = [
    {
        image: "Banner1.jpg",
        title: "Sincronize vendas e produção",
        description: "Elimine gargalos e aumente sua margem de lucro integrando perfeitamente vendas com produção.",
    },
    {
        image: "Banner2.jpg",
        title: "Rastreie tudo em tempo real",
        description: "Monitore cada etapa do processo produtivo e tenha controle total sobre sua operação.",
    },
    {
        image: "Banner3.jpg",
        title: "Maximize a eficiência das máquinas",
        description: "Analise performance em tempo real e tome decisões baseadas em dados concretos.",
    },
];

export default function BannerSlider() {
    const [current, setCurrent] = useState(0);

    useEffect(() => {
        const interval = setInterval(() => {
            setCurrent((prev) => (prev + 1) % slides.length);
        }, 6000);
        return () => clearInterval(interval);
    }, []);

    const openWhatsApp = () => {
        window.open("https://wa.me/5516997640025", "_blank");
    };

    return (
        <div className="relative h-[90vh] overflow-hidden">
            {slides.map((slide, index) => (
                <div
                    key={index}
                    className={`absolute inset-0 bg-cover bg-center transition-all duration-1000 ease-in-out ${current === index ? "opacity-100 scale-100 z-10" : "opacity-0 scale-105 z-0"
                        }`}
                    style={{ backgroundImage: `url(${slide.image})` }}
                >
                    <div className="absolute inset-0 bg-gradient-to-tr from-[#1A4E5FCC] to-[#1ABCBA99]"></div>
                    <div className="relative z-20 flex flex-col items-center justify-center text-center h-full px-4 text-white">
                        <img
                            src="/logo2Finderup2.png"
                            alt="Finder Up Logo"
                            className="w-48 mb-6 filter brightness-0 invert"
                        />
                        <h1 className="text-3xl sm:text-4xl md:text-5xl font-bold mb-4 leading-tight">
                            {slide.title}
                        </h1>
                        <p className="text-base sm:text-lg md:text-xl font-light max-w-2xl mb-6 opacity-90">
                            {slide.description}
                        </p>
                        <a
                            onClick={openWhatsApp}
                            className="bg-teal-500 hover:bg-teal-600 text-white font-semibold text-sm sm:text-base px-6 py-3 rounded-full shadow-lg transition-all"
                        >
                            Quero conversar agora
                        </a>
                    </div>
                </div>
            ))}

            {/* Dots */}
            <div className="absolute bottom-6 left-1/2 transform -translate-x-1/2 flex gap-3 z-30">
                {slides.map((_, index) => (
                    <span
                        key={index}
                        onClick={() => setCurrent(index)}
                        className={`w-3 h-3 rounded-full cursor-pointer transition-all duration-300 ${current === index ? "bg-teal-400 scale-125" : "bg-white/40"
                            }`}
                    />
                ))}
            </div>
        </div>
    );
}